module.exports = __webpack_public_path__ + "img/ir.2e4353f6.svg";